var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{class:("fixed z-50 right-0 bottom-0 mr-5 mb-5 p-4 rounded-md overflow-hidden shadow-xl transform transition-all " + _vm.type)},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }